import * as types from './mutation-types'
import { getCartDot, getCartNum, setPromotion, setProduct, saveLocalCart, clearLocalCart } from 'util/cart'

export const setCartDot = function ({ commit, state }) {
  commit(types.SET_CART_DOT, getCartDot())
}

export const getCartNumber = function ({ commit, state },{numCallBack}) {
  commit(types.SET_CART_NUM, getCartNum(numCallBack))
}

/**对单个促销加入购物车做处理*/
export const setPromotionCart = function ({ commit, state }, { item, isManual }) { 
  commit(types.SET_CART, setPromotion(item, isManual))
}

/**对常规产品加入购物车做处理*/
export const setProductCart = function ({ commit, state }, { item, isManual }) { 
  commit(types.SET_CART, setProduct(item, isManual))
}

/**保存促销或者常规产品type：1促销，2常规,3促销&常规(覆盖)*/
export const saveCart = function ({ commit, state }, { type, item, isManual }) { 
  commit(types.SET_CART, saveLocalCart(type, item, isManual))
}

export const clearCart = function ({ commit, state }) {
  commit(types.SET_CART, clearLocalCart())
}



// WEBPACK FOOTER //
// ./src/store/actions.js